import clsx from "clsx";

export function HeaderCellMenuItem({
    onClick,
    label,
}: {
    onClick: () => void;
    label: string;
}) {
    return (
        <button
            type="button"
            onClick={onClick}
            className={clsx(
                "flex h-[36px] w-full items-center gap-2 rounded-md px-2 py-1.5",
                "menu-item cursor-pointer hover:bg-slate-600",
            )}
            role="menuitem"
        >
            <span className="body-micro cursor-pointer">{label}</span>
        </button>
    );
}
